module.exports = __webpack_public_path__ + "static/coin-75fb80be577c00ca53291d2bb116ce01.png";